module.exports = __webpack_public_path__ + "img/ty2.7eb8e326.png";